


import React, { useEffect, useRef, useState } from "react";
import { Link, NavLink, useNavigate, useParams } from "react-router";
import TopBar from "../components/TopBar";
import Header from "../components/headerfooter/Header";
import Footer from "../components/headerfooter/Footer";
import CallToAction from "../components/home/CallToAction";
import MobileFooter from "../components/MobileFooter";
import axios from "axios";
import { IMAGE_URL, REACT_APP_API_PORT } from "../Api";
import Loader from "../components/Loader";
import moment from "moment/moment";
import {  LuExternalLink, LuShare2 } from "react-icons/lu";
import {  FaCalendarAlt } from 'react-icons/fa';
import { FiChevronDown, FiChevronUp } from "react-icons/fi"; // आइकन्स
import {  FiExternalLink } from "react-icons/fi";
import { AiFillStar, AiOutlineStar } from "react-icons/ai";
import { getDecryptedData } from "../config/crypto";
import { motion, AnimatePresence } from "framer-motion";
import { BiBookmark, BiBookmarkHeart } from "react-icons/bi";
import { toast } from "react-toastify";
import { Helmet } from "react-helmet";
const ToolDetail = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const [data, setData] = useState([]);
  const [featuredTools, setfeaturedTools] = useState([]);
  const [alternativeTools, setalternativeTools] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const sectionRef = useRef(null);

  const scrollToSection = () => {
    sectionRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const getData = async () => {
    try {
      const user = getDecryptedData("user")
      let userId = ""
      if (user) {
        userId = user._id
      }
      const res = await axios.get(`${REACT_APP_API_PORT}user/homepage/tool/show/${id}?userId=${userId}`)
      if (res.data.status) {
        setData(res.data.data)
        setfeaturedTools(res.data.featuredTools)
        setalternativeTools(res.data.alternativeTools)
      }


    }
    catch (err) {
      console.log(err)
    }
  }
  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };



  useEffect(() => {
    getData();
  }, [id]);


  const replaceSpaceWithUnderscore = (str) => {
    return str
      .replace(/[\p{Emoji_Presentation}\p{Extended_Pictographic}]/gu, "") // Remove emojis
      .replace(/\s+/g, "_"); // Replace spaces with underscores
  };

  const handleNavigateToCategory = (label, id) => {
    const name = replaceSpaceWithUnderscore(label)
    localStorage.setItem('FCID', id)
    navigate(`/category/${name}`)
  }

  const handleToolSave = async (toolId) => {
    const user = getDecryptedData("user");
    if (!user) {
      navigate(`/login`)
    }
    if (user) {
      try {
        setisLoading(true)
        const token = getDecryptedData('token')
        const res = await axios.post(`${REACT_APP_API_PORT}user/frontend/save-tool`, {
          tool_id: toolId,
        }, {
          headers: {
            'Content-Type': 'application/json',
            'x-access-token': token
          }
        });
        setisLoading(false)
        if (res.data.status) {
          getData()
        }
      }
      catch (err) {
        setisLoading(false)
        if (err.response.data.status === false) {
          toast.error(err.response.data.message)
        }
      }
    }
  }

  const handleShare = async () => {
    const link = window.location.href;

    if (navigator.share) {
      try {
        await navigator.share({
          title: document.title || 'Check this out!',
          url: link,
        });
      } catch (err) {
        console.error('Error sharing:', err);
      }
    } else {
      try {
        await navigator.clipboard.writeText(link);
        alert('Link copied to clipboard!');
      } catch (err) {
        console.error('Clipboard failed:', err);
      }
    }
  };

  function replaceSpacesWithHyphen(text) {
    return text.replace(/\s+/g, '-');
  }
  return (
    <>
      <Loader isLoading={isLoading} />
      {/* <TopBar /> */}
      <Header />
      <Helmet>
        <title>{data?.meta_title || 'Next Future AI'}</title>
        <meta name="description" content={data?.meta_description || data?.tool_name} />
        <meta name="keywords" content={data?.meta_keywords || data?.tool_name} />
      </Helmet>
      <div ref={sectionRef} className="relative pt-14 pb-8 min-h-screen bg-background-back1 text-white">
        <div className="container max-w-[80rem] mx-auto px-4">
          {/* Breadcrumb */}
          <nav className="max-w-7xl mx-auto text-sm text-slate-300 mb-4" aria-label="Breadcrumb">
            <div className="flex gap-2 items-center flex-wrap">
              <button type="button" onClick={() => navigate("/")} className="hover:text-slate-100">Home</button>
              <span>&gt;</span>
              <button
                type="button"
                onClick={() => handleNavigateToCategory(data?.main_category_id?.category_name, data?.main_category_id?._id)}
                className="hover:text-slate-100">{data?.main_category_id?.category_name}</button>
              <span>&gt;</span>
              <span>{data?.tool_name}</span>
            </div>
          </nav>

          {/* Main Content */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 max-w-7xl mx-auto">
            {/* Left Column */}
            <div className="flex flex-col gap-4">
              <div className="flex gap-4">
                <img
                  src={data.logo ? IMAGE_URL + data.logo + "?type=tool" : "/default.jpeg"}
                  onError={(e) => {
                    e.target.onerror = null; // Prevents infinite loop if default image fails
                    e.target.src = '/default.jpeg';
                  }}
                  alt={data?.logo}
                  className="w-16 h-16 rounded-xl border shadow-sm" />
                <div>
                  <h1 className="text-3xl sm:text-4xl font-semibold text-white">{data?.tool_name}</h1>
                  {
                    (data?.isVerified === "Yes") &&
                    <p className="text-sm text-green-400 mt-1">✔ Verified</p>
                  }

                  <div className="flex items-center gap-1 text-yellow-400 mt-1 text-sm">
                    <AiFillStar />
                    <AiFillStar />
                    <AiFillStar />
                    <AiFillStar />
                    <AiOutlineStar />
                    <span className="text-white text-xs ml-2">(4.0)</span>
                  </div>
                </div>
              </div>

              <div className="text-slate-200 text-base leading-relaxed mt-4 space-y-2">
                {
                  (data?.description) &&
                  <p className="text-xl text-slate-300">{data?.description}</p>
                }

                {
                  (data?.main_category_id) &&
                  <p><strong>AI Category : </strong>
                    <button
                      onClick={() => handleNavigateToCategory(data?.main_category_id?.category_name, data?.main_category_id?._id)}
                      className="text-primary underline">{data?.main_category_id?.category_name}</button>
                  </p>
                }

                <p><strong>Pricing Model : </strong> {data?.payment_type}</p>
            
              </div>

              {/* Action Buttons */}
              <div className="mt-4 flex flex-wrap gap-4">
            
                <button type="button"
                  className="border-2 flex border-customBlue px-4 py-2 rounded text-white hover:bg-background-primary transition text-[15px] font-bold uppercase"
                  onClick={() => handleToolSave(data?._id)}
                >
                  <AnimatePresence mode="wait">
                    {data?.is_saved ? (
                      <motion.div
                        key="saved"
                        initial={{ opacity: 0, scale: 0.5 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.5 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="flex gap-2">
                          <BiBookmarkHeart className="w-5 h-5 text-primary hover:text-white" /> {data?.total_saved}
                        </div>

                      </motion.div>
                    ) : (
                      <motion.div
                        key="unsaved"
                        initial={{ opacity: 0, scale: 0.5 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.5 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="flex gap-2">
                          <BiBookmark className="w-5 h-5 text-primary hover:text-white" /> {data?.total_saved}
                        </div>

                      </motion.div>
                    )}
                  </AnimatePresence>
                </button>

                <NavLink to={data?.visit_link} target="_blank"
                  className="border-2 flex border-customBlue px-4 py-2 rounded text-white hover:bg-background-primary transition text-[15px] font-bold uppercase">
                  <LuExternalLink className="h-5 w-5 mr-2" /> Visit Site
                </NavLink>

                <button
                  onClick={handleShare}
                  className="border-2 flex items-center border-green-600 px-4 py-2 rounded text-white hover:bg-green-700 transition text-[15px] font-bold uppercase"
                >
                  <LuShare2 className="h-5 w-5 mr-2" /> Share
                </button>

                {/* </a> */}
              </div>
            </div>

            {/* Right Column */}
            <div className="flex items-center justify-center">
              <img
                src={data.image ? IMAGE_URL + data.image + "?type=tool" : "/just-launch-default.png"}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = '/just-launch-default.png';
                }}
                // alt="MYPEAS Banner"
                className="w-full rounded-xl shadow-lg border border-gray-100" />
            </div>
          </div>

          <div className="mx-auto mt-10 pt-10 max-w-7xl  xl:px-0 border-t border-white/10">
            <div className="flex flex-col gap-8 md:flex-row">
              {/* Main Content */}
              <main className="flex-1">
                {/* Header Section */}
                <div className="mb-8">
                  <h1 className="text-3xl font-bold text-white border-b border-white/10 pb-4 mb-8">{data?.tool_name} Overview</h1>
                  <div className="mt-2 flex items-center gap-2 text-gray-400">
                    <FaCalendarAlt className="text-gray-500" />
                    Last updated: <span className="font-medium text-white">{moment(data?.updatedAt).format('LL')}</span>
                  </div>
                </div>

                {/* Content */}
                <div className="space-y-8 text-gray-300">
                  {/* What is MYPEAS.AI */}
                  {/* <div
                    className="rich-text-content text-sm lg:text-base xl:text-md font-medium text-gray-400 dark:text-white my-3"
                    dangerouslySetInnerHTML={{ __html: data?.details }}
                  /> */}
                  <div
                    className="rich-text-content text-sm lg:text-base xl:text-md font-medium my-3"
                    dangerouslySetInnerHTML={{ __html: data?.details }}
                  />
           

                  {
                    (data?.faqs?.length > 0) &&
                    <section className="mt-8">
                      <h2 className="mb-6 text-2xl font-bold text-white">Frequently Asked Questions</h2>

                      <div className="space-y-4">
                        {data?.faqs?.map((faq, index) => (
                          <div
                            key={index}
                            className="rounded-lg bg-background-back2 p-4 cursor-pointer transition-all duration-300"
                            onClick={() => toggleFAQ(index)}
                          >
                            <div className="flex justify-between items-center">
                              <h3 className="text-lg font-semibold text-white">{faq.question}</h3>
                              {activeIndex === index ? (
                                <FiChevronUp className="text-white text-xl" />
                              ) : (
                                <FiChevronDown className="text-white text-xl" />
                              )}
                            </div>

                            <div
                              className={`overflow-hidden transition-all duration-300 ease-in-out ${activeIndex === index ? "max-h-40 mt-2" : "max-h-0"
                                }`}
                            >
                              <p className="text-gray-300 pt-2">
                                {faq.answer}
                              </p>
                            </div>
                          </div>
                        ))}
                      </div>
                    </section>
                  }


                </div>
              </main>

              {/* Sidebar */}
              <aside className="md:w-80">
                <div className="sticky top-20 space-y-6">
                  <div className="rounded-xl ">
                    <h3 className="text-3xl font-bold text-white border-b border-white/10 pb-4 mb-8">Featured AI Tools</h3>
                    <div className="space-y-4">
                      {featuredTools.map((tool, index) => (
                        <div key={index}
                          onClick={() => {
                            // navigate(`/tool-detail/${tool?._id}`)
                            if (tool?.tool_name) {
                              navigate(`/tool-detail/${replaceSpacesWithHyphen(tool?.tool_name)}/${tool?._id}`)
                            }
                            else {
                              navigate(`/tool-detail/${tool?._id}`)
                            }
                            scrollToSection()
                          }}
                          className="rounded-lg bg-background-back2 p-4 transition cursor-pointer">
                          <div className="flex items-center gap-3">
                            <img
                              src={tool?.logo ? IMAGE_URL + tool.logo + "?type=tool" : "/default.jpeg"}
                              alt={tool?.tool_name}
                              className="h-12 w-12 rounded-full object-cover border border-gray-600"
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = "/default.jpeg"
                              }}
                            />
                            <div>
                              <h4 className="font-semibold text-white">{tool.tool_name}</h4>
                              <p className="text-sm ">{tool.main_category_id ? tool.main_category_id.category_name : ""}</p>
                            </div>
                          </div>
                          <p className="mt-2 text-sm text-gray-300 line-clamp-3">{tool.description}</p>
                          <img
                            src={tool.image ? IMAGE_URL + tool.image + "?type=tool" : "/just-launch-default.png"}
                            onError={(e) => {
                              e.target.onerror = null; // Prevents infinite loop if default image fails
                              e.target.src = '/just-launch-default.png';
                            }}
                            alt={tool?.tool_name}
                            className="w-full mt-3 rounded-lg object-cover h-32"
                          />

                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </aside>
            </div>
          </div>
          <div className="mx-auto mt-10 py-8">
            {/* Section Header */}
            <h2 className="text-2xl font-bold text-white mb-6">{data?.tool_name} alternatives</h2>

            {/* Tools Grid - 4 columns */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {
                (alternativeTools && alternativeTools?.length > 0) && alternativeTools?.map((item, index) => {
                  return <>
                    <div

                      className="group bg-background-back2 rounded-xl overflow-hidden shadow-lg p-4 transition-all duration-300 ">
                      <div
                        onClick={() => {
                          // navigate(`/tool-detail/${item?._id}`)
                          if (item?.tool_name) {
                            navigate(`/tool-detail/${replaceSpacesWithHyphen(item?.tool_name)}/${item?._id}`)
                          }
                          else {
                            navigate(`/tool-detail/${item?._id}`)
                          }
                          scrollToSection()
                        }}
                        className="cursor-pointer">
                        <div className="flex items-center gap-3 mb-3">
                          <img
                            src={item.logo ? IMAGE_URL + item.logo + "?type=tool" : "/default.jpeg"}
                            // onError={(e)=>e.src.target='/default.jpeg'}
                            onError={(e) => {
                              e.target.onerror = null; // Prevents infinite loop if default image fails
                              e.target.src = '/default.jpeg';
                            }}
                            alt={`${item.tool_name} logo`}
                            className="h-12 w-12 rounded-full object-cover border-2 border-gray-700 group-hover:border-primary transition-colors"
                          />
                          <div className="flex-1 min-w-0">
                            <h5 className="text-lg font-bold text-white truncate">{item?.tool_name}</h5>
                            <a className="text-sm">
                              {item?.main_category_id?.category_name}
                            </a>
                          </div>
                        </div>
                        <p className="text-sm text-gray-400 mb-4 truncate">
                          {item?.description}
                        </p>
                        <div className="relative rounded-lg overflow-hidden mb-4">
                          <img
                            src={item.image ? IMAGE_URL + item.image + "?type=tool" : "/just-launch-default.png"}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = '/just-launch-default.png';
                            }}
                            className="w-full h-40 object-cover group-hover:scale-105 transition-transform duration-500"
                          />
                        </div>
                      </div>
                      <div className="flex justify-between items-center">
                        <span className="text-sm font-medium text-gray-300 ">
                          Freemium
                        </span>
                        <div className="flex gap-2">
                          {/* <button className="p-2 text-gray-400 hover:text-white transition-colors">
                            <FiBookmark size={20} />
                          </button> */}
                          <button type="button" onClick={() => handleToolSave(item?._id)}>
                            <AnimatePresence mode="wait">
                              {item?.is_saved ? (
                                <motion.div
                                  key="saved"
                                  initial={{ opacity: 0, scale: 0.5 }}
                                  animate={{ opacity: 1, scale: 1 }}
                                  exit={{ opacity: 0, scale: 0.5 }}
                                  transition={{ duration: 0.3 }}
                                >
                                  <BiBookmarkHeart className="w-5 h-5 text-primary hover:text-white" />
                                </motion.div>
                              ) : (
                                <motion.div
                                  key="unsaved"
                                  initial={{ opacity: 0, scale: 0.5 }}
                                  animate={{ opacity: 1, scale: 1 }}
                                  exit={{ opacity: 0, scale: 0.5 }}
                                  transition={{ duration: 0.3 }}
                                >
                                  <BiBookmark className="w-5 h-5 text-primary hover:text-white" />
                                </motion.div>
                              )}
                            </AnimatePresence>
                          </button>
                          <Link to={item?.visit_link} target="_blank" className="ml-2">
                            <FiExternalLink className="text-primary w-5 h-5" />
                          </Link>
                         
                        </div>
                      </div>
                    </div>
                  </>
                })
              }

            </div>
          </div>
        </div>
      </div>

      <CallToAction />
      <Footer />
      <MobileFooter />
    </>
  );
};

export default ToolDetail;